import type { SelectorObject } from '../types';

export const perUnitUsageChargeEditBottomSectionSelectors = {
  trashButton: 'per-unit-usage-charge-edit-bottom-section-trash-button',
} satisfies SelectorObject<'per-unit-usage-charge-edit-bottom-section-'>;